export default __webpack_public_path__ + "static/media/navbar-rules-orange.1c240639.svg";